import { Skeleton } from '@mui/material';
import { ImageName, ImageWrapper } from './image-library.styles';

export const ImageLibrarySkeleton = () => {
  return (
    <>
      {Array.from({ length: 8 }).map((_, index) => (
        <ImageWrapper key={index}>
          <Skeleton variant="text" width={110} height={110} sx={{ borderRadius: '4px', transform: 'scale(1, 1)' }} />
          <ImageName sx={{ width: 'auto' }}>
            <Skeleton variant="text" width={90} height={20} />
          </ImageName>
        </ImageWrapper>
      ))}
    </>
  );
};
